








// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";

export default defineComponent({
	props:{
		translateKey:{
			type:String,
			default:""
		},
	},
	setup(props, context){

		const {
			translate,
		} = useTranslate(context);

		const title = computed(() => translate(props.translateKey));

		return {
			title,
		};
	}
});

